'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z' });

var BorderStyle = function BorderStyle(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

BorderStyle = (0, _pure2.default)(BorderStyle);
BorderStyle.muiName = 'SvgIcon';

exports.default = BorderStyle;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/BorderStyle.js
// module id = 2190
// module chunks = 0